import Details from "./Details";
import SubText from "components/shared/SubText";
import SuggestedSection from "./SuggestedSection";
import EpisodeCoursel from "./EpisodeCoursel";

type Person = { name?: string; slug?: string };

type Episode = { id?: string | number };

type Season = {
  id?: string | number;
  name?: string;
  episodes?: Episode[];
};

type Video = {
  id?: string | number;
  slug?: string;
  plan_id?: string | number;
  country?: string;
  tags?: string | Array<string | { name?: string }>;
  allowed_to_watch?: boolean;
  seasons?: Season[];
  directors?: Person[];
  producers?: Person[];
  actors?: Person[];
};

type InfoPageProps = {
  video?: Video;
  isLoading?: boolean;
  similarContent?: unknown[];
};

function InfoPage({ video, isLoading, similarContent }: InfoPageProps) {
  const seasons = video?.seasons ?? [];
  const showSeasons = !!video?.allowed_to_watch && seasons.length > 0;
  const hasSuggestions = !!similarContent?.length;

  return (
    <div className="mt-10 ml-3">
      {/* Video details */}
      <Details video={video} isLoading={isLoading} />

      {/* TV series seasons */}
      {showSeasons && (
        <section>
          <p className="mt-8 my-1 flex h-[40px] max-w-[120px] cursor-pointer items-center justify-center rounded-md border-b border-[#f30543] p-3 text-center !text-[#f30543] max-sm:ml-0 max-sm:p-2">
            {seasons.length === 1 ? "SEASON" : "SEASONS"}
          </p>

          {seasons.map((season, i) => (
            <EpisodeCoursel
              key={season?.name ?? i}
              text={season?.name}
              season={season}
              seriesId={video?.id}
              slug={video?.slug}
              plan_id={video?.plan_id}
            />
          ))}
        </section>
      )}

      {/* Suggestions */}
      {hasSuggestions && (
        <section className="my-5 mt-10">
          <SubText text="You may also like these" className="font-light" />
          <SuggestedSection video={similarContent} />
        </section>
      )}
    </div>
  );
}

export default InfoPage;